import React, { Component } from 'react';
import _ from 'lodash';
import AnalyticsScrollMenu from 'views/Analytics/AnalyticsScrollMenu/AnalyticsScrollMenu';
import AnalyticsPlaceholder from 'views/Analytics/Placeholder/AnalyticsPlaceholder';
import { ApplicationState } from 'store/rootReducer';
import { connect } from 'react-redux';
import {
  closeAnalyticsTabThunk,
  createAnalyticsTabItemThunk,
  selectTabThunk,
} from 'store/analytics/ui/analyticsUiActions';
import { RouteComponentProps } from 'react-router';
import { getIdFromSlug } from 'utils/urlUtils';
import { AnalyticsReport, AnalyticsTabItem } from 'store/analytics/ui/analyticsUiTypes';
import { analyticsReportTypes } from 'store/analytics/analyticsReportTypes';
import { MockServiceAnalytics } from 'types/rest/mockServiceTypes';
import AnalyticsMockService from 'views/Analytics/AnalyticsMockService/AnalyticsMockService';
import styles from 'views/Analytics/Analytics.module.css';
import clsx from 'clsx';
import MixpanelService from 'utils/mixpanelService';
import { ANALYTICS_TAB_CLOSED } from 'utils/mixpanelEvents';
import AnalyticsReadOnly from 'views/Analytics/Placeholder/AnalyticsReadOnly';
import { WithTranslation, withTranslation } from 'react-i18next';

type AllProps = DispatchProps & StateProps & RouteComponentProps & WithTranslation;

export class Analytics extends Component<AllProps> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    // Open tab
    this.openTabFromUrlParam(true).then();
  }

  /**
   * Selects tab according slug value in the url.
   */
  openTabFromUrlParam = async (forceReload: boolean) => {
    if (forceReload) {
      //TODO - reload ms data from metadata endpoint
      //await this.props.getMockServicesByCriteria();
    }

    const slug = (this.props.match.params as any).slug;
    if (slug !== undefined && this.props.mockServices) {
      // Check if it is an id of a report or virtual service
      const extractedId: any = getIdFromSlug(slug);
      let tabToOpen: AnalyticsReport | MockServiceAnalytics | undefined;
      if (!isNaN(extractedId)) {
        tabToOpen = this.props.mockServices.find(ms => ms.id.toString() === extractedId.toString());
      } else {
        tabToOpen = analyticsReportTypes.find(item => item.slug === slug);
      }

      // TODO - redirect on a special 404 page when a virtual service is not available, TBD
      tabToOpen ? this.props.createAnalyticsTabItem(tabToOpen) : _.noop();
    }
  };

  onSelectHandler = (key: any) => {
    // Create friendly URL
    const tabItem: AnalyticsTabItem | undefined = this.props.tabs.find(item => item.id.toString() === key.toString());
    if (tabItem === undefined || String(this.props.selected) === String(key)) return;

    // Friendly URL navigation
    // const url = '/analytics/' + tabItem.slug;
    // this.props.history.push(url);

    this.props.selectTab(key);
  };

  closeTabHandler = async (event: any, id: any) => {
    // Stop propagation of the click otherwise horizontal-menu
    // component will trigger onSelect handler
    event.stopPropagation();
    MixpanelService.track(ANALYTICS_TAB_CLOSED(id));
    await this.props.closeAnalyticsTab(id);

    // Friendly URL navigation
    // Get currently selected item and navigate browser there
    // const currentTabItem: AnalyticsTabItem | undefined = this.props.tabs.find(item => item.id === this.props.selected);
    // if (currentTabItem !== undefined) {
    //   this.props.history.push('/analytics/' + currentTabItem.slug);
    // } else {
    //   this.props.history.push('/analytics');
    // }
  };

  /**
   * Shows detail based on the selected tab. It can be either Virtual Service or Report.
   */
  analyticsTypeSelector = () => {
    const selectedItem: AnalyticsTabItem | undefined = this.props.tabs.find(
      tab => tab.id.toString() === this.props.selected,
    );

    // Virtual Service view
    if (selectedItem !== undefined) {
      return <AnalyticsMockService mockService={selectedItem.meta} />;
    }

    // Fallback info
    return <span>Selected Virtual Service is not available.</span>;
  };

  render = () => {
    let content;

    // Disable view for private cloud Read only mode
    if (this.props.isReadOnlyInPrivateCloud) {
      content = <AnalyticsReadOnly />;
    } else {
      content = this.props.selected === null ? <AnalyticsPlaceholder /> : this.analyticsTypeSelector();
    }
    return (
      <div className={clsx('container-fluid', styles.AnalyticsContainer)}>
        <AnalyticsScrollMenu
          items={this.props.tabs}
          selected={this.props.selected}
          selectTabHandler={this.onSelectHandler}
          closeTabHandler={this.closeTabHandler}
          disabled={this.props.isReadOnlyInPrivateCloud}
        />
        <div id="analytics-card" className={clsx('card flex-grow-1', this.props.selected === null ? 'mb-0' : 'mb-4')}>
          <div className="card-body">{content}</div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = ({ analytics, blazeUserConfig }: ApplicationState) => ({
  tabs: analytics.ui.tabs,
  selected: analytics.ui.activeTab,
  mockServices: analytics.ui.mockServices,
  isMockServiceMetadataInitialised: analytics.ui.isMockServiceMetadataInitialised,
  blazeUserConfig: blazeUserConfig.blazeUserConfig,
  isReadOnlyInPrivateCloud: blazeUserConfig.isPrivateCloudReadOnly,
});

const mapDispatchToProps = {
  closeAnalyticsTab: closeAnalyticsTabThunk,
  selectTab: selectTabThunk,
  createAnalyticsTabItem: createAnalyticsTabItemThunk,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default withTranslation('analytics')(connect(mapStateToProps, mapDispatchToProps)(Analytics));
